<template lang="pug">
div Εισαγωγή Κολλεγίου-Σχολής-Τμήματος {{title.country.name}}
  el-form(ref='title', :inline='true', :inline-message="true", :model='title',
    label-width='160px', size='small')
    el-card.box-card(shadow="always")
      .clearfix(slot='header')
        span Κολλέγια επιλεγμένου Πανεπιστημίου
      .text.item
        el-form-item(label='Κολλέγιο', prop="college.name")
          el-select.big(v-model='college.name' , @change="collegeSelected",
            placeholder='Κολλέγια', filterable)
            el-option(v-for="college in colleges", :key="college.id",
              :label="college.name", :value="college.id")
        el-form-item(label='Σχολή', prop="faculty.name")
          el-select.big(v-model='collegeFaculty.name' , @change="facultySelected",
            placeholder='Σχολές Επιλεγμένου Κολλεγίου', :disabled="disableFaculty", filterable)
            el-option(v-for="faculty in collegeFaculties", :key="faculty.id",
              :label="faculty.name", :value="faculty.id")
        el-form-item(label='Τμήμα', prop="department.name")
          el-select.big(v-model='collegeDepartment.name' , @change="departmentSelected",
            placeholder='Τμήματα Επιλεγμένης Σχολής', :disabled="disableDepartment", filterable)
            el-option(v-for="department in colFacDepartments", :key="department.id",
              :label="department.name", :value="department.id")
              | {{department.name.length > 30 ? department.name.substring(0, 28) + '...' : department.name}}
      div(style="text-align: center")
        el-button(size='mini', type='primary', round='', @click='save') Καταχώρηση
</template>

<script>
import config from '../../config.js'
import axios from 'axios'
import sharedMethods from '@/components/common/sharedMethods.js'

export default {
  props: {
    title: {
      type: Object,
      required: true
    },
    consideration: {
      type: Boolean,
      required: false
    },
    applicationId: {
      type: Number,
      required: true
    }
  },
  mixins: [sharedMethods],
  data () {
    return {
      college: {id: null, name: null}, // this.title.college,
      collegeDepartment: {id: null, name: null}, // this.title.department, // {id: Number, name: ''},
      collegeFaculty: {id: null, name: null}, // this.title.faculty, // {id: Number, name: ''},
      colFacDept: {},
      disableDepartment: true,
      disableFaculty: true,
      colleges: [],
      collegeFaculties: [],
      colFacDepartments: [],
      faculties: [],
      departments: []
    }
  },
  computed: {
    name () {
      return this.data
    },
    appId () {
      this.getFacultiesCollegesDepartments(this.title.country.id, this.title.university.id)
      return this.title.university.id
    }
  },
  methods: {
    save () {
      axios.put(`${config.BASE_URL}/applications/${this.applicationId}/degree_institution`,
        {
          titleInstitutionData: {
            considerationTitle: this.consideration,
            college: {
              id: this.college.id,
              name: this.college.name
            },
            faculty: {
              id: this.collegeFaculty.id,
              name: this.collegeFaculty.name
            },
            department: {
              id: this.collegeDepartment.id,
              name: this.collegeDepartment.name
            }
          }
        }
      ).then((response) => {
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.applicationId)
        this.$notify.success({
          title: 'Ειδοποίηση',
          message: 'Τα στοιχεία κολλεγίου/σχολής/τμήματος αποθηκεύτηκαν με επιτυχία',
          offset: 100
        })
      }).catch(err => this.catchError(err))
    },
    catchError (err) {
      this.backendError(err)
      throw err
    },
    getFacultiesCollegesDepartments (country, university) {
      axios.get(`${config.BASE_URL}/countries/${country}/universities/${university}`)
        .then((response) => {
          // all {colleges:[] {faculties:[] {departments:[]}}, Faculties:[] {departments:[]}} for university
          this.colFacDept = response.data.data
          // get the university colleges:[{faculties:[{departments[]},...]},...]
          this.colleges = this.colFacDept.colleges
          // get the university faculties: [{departments[]},...]
          this.faculties = this.colFacDept.faculties
          this.collegeFaculties = []
          // If college.name get its faculties else get all university faculties
          if (this.title.college.name != null && this.title.college.name !== 'other') {
            this.colleges.find(col => col.id === this.title.college.id)
              .faculties.forEach(fac => this.collegeFaculties.push(fac))
          }
          this.colFacDepartments = []
          this.departments = []
          // If faculty.name
          //    if college.name {get all collegeFaculty departments}
          //    else {get all faculties departments}
          // else leave departments empty as they are hidden
          if (this.title.faculty.name != null && this.title.faculty.name !== 'other') {
            if (this.title.college.name != null && this.title.college.name !== 'other') {
              this.collegeFaculties.find(fac => fac.id === this.title.faculty.id)
                .departments.forEach(depar => this.colFacDepartments.push(depar))
            } else {
              this.faculties.find(fac => fac.id === this.title.faculty.id)
                .departments.forEach(depar => this.departments.push(depar))
            }
          }
        }).catch(err => {
          this.backendError(err)
        })
      this.disableFaculty = true
      this.disableDepartment = true
    },
    collegeSelected (college) {
      this.collegeFaculty = {id: null, name: null}
      this.collegeDepartment = {id: null, name: null}
      this.college = {id: null, name: null}
      this.college.name = this.colleges.find(col => col.id === college).name
      this.college.id = college
      this.collegeFaculties = this.colleges.find(col => col.id === college).faculties
      this.disableFaculty = false
    },
    facultySelected (faculty) {
      this.collegeDepartment = {id: null, name: null}
      this.collegeFaculty.id = faculty
      this.collegeFaculty.name = this.collegeFaculties
        .find(fac => fac.id === faculty).name
      this.colFacDepartments = this.collegeFaculties
        .find(fac => fac.id === faculty).departments
      this.disableDepartment = false
    },
    departmentSelected (department) {
      this.collegeDepartment.id = department
      this.collegeDepartment.name = this.colFacDepartments
        .find(dep => dep.id === department).name
    }
  },
  watch: {
    appId: function (newVal, oldVal) {
      // this.getFacultiesCollegesDepartments(newVal.country.id, newVal.university.id)
    }
    // title: {
    //   handler: function (newVal, oldVal) {
    //     this.getFacultiesCollegesDepartments(newVal.country.id, newVal.university.id)
    //   },
    //   // immediate: true,
    //   deep: true
    // }
  }
}
</script>

<style lang="scss" scoped>
.big {
  &.el-select {
    width: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SelectColFacDep.vue